var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkipped(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1863_2570",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1863_2570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66668 8.66658H11.3333V7.33325H4.66668V8.66658ZM8.00001 14.6666C7.07779 14.6666 6.21112 14.4915 5.40001 14.1413C4.5889 13.7915 3.88334 13.3166 3.28334 12.7166C2.68334 12.1166 2.20845 11.411 1.85868 10.5999C1.50845 9.78881 1.33334 8.92214 1.33334 7.99992C1.33334 7.0777 1.50845 6.21103 1.85868 5.39992C2.20845 4.58881 2.68334 3.88325 3.28334 3.28325C3.88334 2.68325 4.5889 2.20814 5.40001 1.85792C6.21112 1.50814 7.07779 1.33325 8.00001 1.33325C8.92223 1.33325 9.7889 1.50814 10.6 1.85792C11.4111 2.20814 12.1167 2.68325 12.7167 3.28325C13.3167 3.88325 13.7916 4.58881 14.1413 5.39992C14.4916 6.21103 14.6667 7.0777 14.6667 7.99992C14.6667 8.92214 14.4916 9.78881 14.1413 10.5999C13.7916 11.411 13.3167 12.1166 12.7167 12.7166C12.1167 13.3166 11.4111 13.7915 10.6 14.1413C9.7889 14.4915 8.92223 14.6666 8.00001 14.6666ZM8.00001 13.3333C9.4889 13.3333 10.75 12.8166 11.7833 11.7833C12.8167 10.7499 13.3333 9.48881 13.3333 7.99992C13.3333 6.51103 12.8167 5.24992 11.7833 4.21658C10.75 3.18325 9.4889 2.66659 8.00001 2.66659C6.51112 2.66659 5.25001 3.18325 4.21668 4.21658C3.18334 5.24992 2.66668 6.51103 2.66668 7.99992C2.66668 9.48881 3.18334 10.7499 4.21668 11.7833C5.25001 12.8166 6.51112 13.3333 8.00001 13.3333Z",
    fill: "#828282"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipped);
export default __webpack_public_path__ + "static/media/skipped.33220989f5199704f652f1e3f99dbfe1.svg";
export { ForwardRef as ReactComponent };